import React, { useEffect } from 'react'
import './App.scss'

import './i18n/i18n'
import { FiltersProvider } from './Context/FiltersContext'
import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from './router/app-router'
import { useTranslation } from 'react-i18next'

function App() {
  const { t }: any = useTranslation()
  useEffect(() => {
    document.title = t('pageTitle') || 'Litio en Conflicto'
  }, [])

  return (
    <BrowserRouter>
      <FiltersProvider>
        <AppRouter></AppRouter>
      </FiltersProvider>
    </BrowserRouter>
  )
}

export default App
